import { schema } from "normalizr";
// nested entiies schemas
import deviceSchema from "./device";
import pageSchema from "./page";
import wevoAudienceSchema from "./wevo-audience";

const wevoSchema = new schema.Entity(
    "wevos",
    {
        audiences: [wevoAudienceSchema],
        devices: [deviceSchema],
        pages: [pageSchema]
    },
    {
        idAttribute: "id"
    }
);

export default wevoSchema;



// WEBPACK FOOTER //
// ./src/schemas/wevo.js